import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

import IIGAddressCard from "./IIGAddressCard";

// Extended-field type ID for an Address field (matches the legacy
// `extendedFieldTypes` map and updateSingleField.js's guard).
const ADDRESS_FIELD_TYPE_ID = 4;

/**
 * Bridges the IIG single-field page (`/user/updateField/{fieldID}/sure`) to the
 * React Address card. Reads the PHP bootstrap on `window.data.assets`, and only
 * takes over when the holder node exists AND the field being edited is an
 * Address — for every other field type the legacy widget still renders.
 */
export default function IIGAddressPortal() {
  const portalElement = usePortalElement(".iig_address_react_holder");

  const assets = window.data?.assets;
  const extendedField = assets?.extendedField;

  if (!portalElement) return null; // non-React area hasn't loaded yet
  if (!extendedField || extendedField.fieldTypeID !== ADDRESS_FIELD_TYPE_ID)
    return null;

  const countryVisible = Boolean(
    extendedField.configuration?.subfields?.country?.isVisible
  );

  return (
    <Portal to={portalElement}>
      <IIGAddressCard
        userID={assets.userID}
        iigRequestID={assets.iigRequestID ?? null}
        networkFieldID={extendedField.networkFieldID}
        fieldTypeInstanceID={extendedField.fieldTypeInstanceID}
        initialValue={extendedField.response}
        countryVisible={countryVisible}
        otherNetworks={assets.otherNetworks || []}
      />
    </Portal>
  );
}
